import { signOut } from "aws-amplify/auth";
import { performSignOut } from "shared/src/utils/perform-sign-out";
import graphQLClient from "./apollo-client";

const REDIRECT_URL = "/";

export async function signOutUser(): Promise<void> {
  await performSignOut({
    amplifySignOut: signOut,
    apolloClient: graphQLClient,
    redirectUrl: REDIRECT_URL,
  });
}
